import React from 'react'

const SDEL = () => {
  return (
    <div>SDEL</div>
  )
}

export default SDEL